module.exports = __webpack_public_path__ + "static/ui-panel-91612515ebd0c556856f3debff64245e.png";